<nav #header *ngIf="renderMenu" class=" fixed-top headerStyle"
    [ngClass]="{'navbar2': this.companyParamsService.getFadeMenu()}"
    style='background-color: white;filter: drop-shadow(1px 1px 1px #6666664d);'>
    <div #header1 class="green containerMenu margin">
        <div *ngIf="companyParamsService.getHasLogoInformation()" class="tooltip fade show bs-tooltip-right"
            role="tooltip" id="tooltip164687" x-placement="right"
            style="position: absolute; will-change: transform; top: 0px; left: 0px; transform: translate3d(266px, 24px, 0px);">
            <div class="arrow" style="top: 8px;"></div>
            <div class="tooltip-inner">Your Logo Here</div>
        </div>
        <a *ngIf="!this.companyParamsService.getWebSite()" class="navbar-brand" target="_blank" class="navbar-brand"
            data-container=".green" data-toggle="tooltip" data-placement="right" title="Your Logo Here"
            style="display: flex; align-items: center;">
            <img src="assets/images/logos-header/tf.svg" height="84" alt="logo">
        </a>
        <a *ngIf="this.companyParamsService.getWebSite()" href="https://www.ecuadortierradefuego.com/?lang=en"
            class="navbar-brand" target="_blank" style="display: flex; align-items: center;">
            <input type="hidden" value="{{this.companyParamsService.getCompanyParams().logoFade}}" id="logoFade">
            <input type="hidden" value="{{this.companyParamsService.getCompanyParams().fadeMenu}}" id="fadeMenu">
            <img src="assets/images/logos-header/tf.svg" height="84" alt="logo">
        </a>
        <div class="containerMenu navbar-collapse collapse" style="justify-content: center;">
            <ul class="navbar-nav menuContainer" style="width: 100%; padding: 12px 30px;">
                <li class="nav-item menuItem"><a href="https://www.ecuadortierradefuego.com/ofertas?lang=en"
                        target="_blank">DEALS</a></li>
                <li class="nav-item menuItem"><a href="https://www.ecuadortierradefuego.com/planifica-tu-viaje?lang=en"
                        target="_blank">PLAN YOUR TRIP</a>
                </li>
                <li class="nav-item menuItem"><a href="https://www.ecuadortierradefuego.com/sobre-nosotros?lang=en"
                        target="_blank">ABOUT US</a></li>
                <li class="nav-item menuItem"><a href="https://www.ecuadortierradefuego.com/cont%C3%A1ctanos?lang=en"
                        target="_blank">CONTACT US</a>
                </li>
                <li>
                    <div>
                        <a class="lets-talk-button" href="https://www.ecuadortierradefuego.com/?lang=en"
                            style="color: white;">
                            <img src="assets/images/us_round.png" height="22" style="margin-right: 5px;">English
                        </a>
                    </div>
                </li>
            </ul>

        </div>
        <div class="button-container">
            <div *ngIf="companyParamsService.getFiltersInterest()" class="wishlist tooltip-container">
                <app-heart-header></app-heart-header>
            </div>
        </div>
    </div>
    <div class="responsiveHeader">
        <div class="container green containerHeader"
            style="display:flex;justify-content: space-between; flex-direction: row!important;align-items: center;">
            <img src="assets/images/logos-header/tf.svg" height="60" />
            <a class="menuButton" (click)="renderMenu()" href="javascript:void()" style="padding-right: 1em;">
                <i class="fa fa-bars fa-2x"
                    style="color:rgb(16, 142, 206) !important; padding: 8px; border: 1px solid rgb(184, 206, 40); border-radius: 10px;"></i>
            </a>
        </div>
    </div>
    <ul style="width: inherit; display: none;" class="menuContainer" [ngClass]="showMenu ? 'showMenu':''">
        <li class="nav-item menuItem" style="display: flex;">
            <a class="flag-button" href="https://www.ecuadortierradefuego.com/?lang=en" style="color: white;">
                <img src="assets/images/ec_round.png" height="22" style="margin-right: 5px;">ES
            </a>
            <a class="flag-button" href="https://www.ecuadortierradefuego.com/?lang=en" style="color: white;">
                <img src="assets/images/us_round.png" height="22" style="margin-right: 5px;">EN
            </a>
        </li>
        <li class="nav-item menuItem"><a href="https://www.ecuadortierradefuego.com/ofertas?lang=en"
                target="_blank">DEALS</a></li>
        <li class="nav-item menuItem"><a href="https://www.ecuadortierradefuego.com/planifica-tu-viaje?lang=en"
                target="_blank">PLAN YOUR TRIP</a>
        </li>
        <li class="nav-item menuItem"><a href="https://www.ecuadortierradefuego.com/sobre-nosotros?lang=en"
                target="_blank">ABOUT US</a></li>
        <li class="nav-item menuItem"><a href="https://www.ecuadortierradefuego.com/cont%C3%A1ctanos?lang=en"
                target="_blank">CONTACT US</a>
        </li>
    </ul>
    <div *ngIf="companyParamsService.getFiltersInterest()" class="wishlist tooltip-container"
        [ngClass]="showMenu ? 'showMenu':''" style="width: inherit; display: none;">
        <app-heart-header></app-heart-header>
    </div>
</nav>